import PropTypes from "prop-types"
import React, { useState } from "react"
import Button from "components/Button"
import HubspotFormEmbed from "components/HubspotFormEmbed"
import Modal from "components/Modal"
import * as css from "./NewsletterModal.module.css"
import SectionHeader from "components/Layout/SectionHeader"

function NewsletterModal({
  formId,
  title = "Join our newsletter",
  subtitle = "Get the latest updates from Preset",
  thankYouTitle = "Thank you",
  thankYouSubtitle = "You may unsubscribe at anytime",
  closeModal,
  trackSubmit,
}) {
  const [isDone, setIsDone] = useState(0)

  return (
    <Modal onClose={closeModal} size="tiny">
      <SectionHeader
        title={!isDone ? title : thankYouTitle}
        subtitle={!isDone ? subtitle : thankYouSubtitle}
        centered
        margin="extraLight"
      />
      {!isDone ? (
        <HubspotFormEmbed
          formId={formId}
          trackSubmit={trackSubmit}
          onSubmit={() => setIsDone(true)}
          className={css.newsletterModal}
        />
      ) : (
        <div style={{ textAlign: "center" }}>
          <Button type="button" primary onClick={closeModal}>
            Go back
          </Button>
        </div>
      )}
    </Modal>
  )
}

NewsletterModal.propTypes = {
  formId: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  thankYouTitle: PropTypes.string,
  thankYouSubtitle: PropTypes.string,
  closeModal: PropTypes.func,
  trackSubmit: PropTypes.string,
}

export default NewsletterModal
